import React from "react";
import PropTypes from "prop-types";
import { getLogoURLWhite, getBlueLogoUrl } from "../../../constants/url-constants";

const LOGO_SOURCES = {
    primary: getBlueLogoUrl(),
    white: getLogoURLWhite()
};

const LOGO_DIMENSIONS = {
    icon: { width: 36, height: 36 },
    iconWithText: { width: 120, height: 36 }
};

const Logo = ({ width, height, type = "iconWithText", colour = "primary" }) => {
    const src = LOGO_SOURCES[colour] || LOGO_SOURCES.primary;
    const defaultSize = LOGO_DIMENSIONS[type] || LOGO_DIMENSIONS.iconWithText;

    const style = {
        width: width || defaultSize.width,
        height: height || defaultSize.height,
        objectFit: "contain"
    };

    return <img style={style} src={src} alt="CARS24" />;
};

Logo.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    type: PropTypes.oneOf(["icon", "iconWithText"]),
    colour: PropTypes.oneOf(["primary", "white"])
};

export default Logo;
